import React, { Fragment, useState } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  CardHeader,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import {
  useMyOrgInfo,
  useUserEmail,
} from "../../Layout/AppMain/LoginStatusContext";
import DissolveBadge from "../../components/DissolveBadge";
import { Modal, ModalBody } from "reactstrap";
import styles from "./index.module.scss";
import { useQuery } from "@apollo/client";
import {
  GET_USER_PROF,
  QUERY_MY_SUPPORTER_INFO,
  USER_ORG_ID,
} from "../../queries";

const InfoTable = ({
  orgListData,
  title,
  hideButtonCsv,
  refetch,
  ...props
}) => {
  const { paginationComponent = null } = props;
  const userOrgInfo = useMyOrgInfo();
  const [csvLists, setCsvLists] = useState([]);
  const [pricingModalOpen, setPricingModalOpen] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  //チェックした団体idをcsvListsに追加
  const handleCheckBox = (val) => {
    let csvArray = [...csvLists, val];

    if (csvLists.includes(val)) {
      csvArray = csvArray.filter((id) => id !== val);
    } else {
    }

    setCsvLists(csvArray);
  };

  const userEmail = useUserEmail();
  const isUnauthenticated = !userEmail;
  const {
    loading,
    error,
    data,
    refetch: refetchUserTicket,
  } = useQuery(GET_USER_PROF, {
    variables: { email: userEmail },
  });
  const { data: csoData, refetch: refetchCSOTicket } = useQuery(USER_ORG_ID, {
    variables: { email: userEmail },
  });
  const cso =
    csoData?.allUsers?.edges?.[0]?.node?.role?.edges?.[0]?.node?.organization;
  const { data: supporterData, refetch: refetchSupporterTicket } = useQuery(
    QUERY_MY_SUPPORTER_INFO
  );
  const userTicket = data?.allUsers?.edges[0]?.node?.totalTicket;
  const supporterTicket =
    supporterData?.mySupporterInfo?.edges[0]?.node?.totalTicket;

  const userIsCso = data?.allUsers?.edges[0]?.node?.isCso ?? false;
  const userIsSupporter = data?.allUsers?.edges[0]?.node?.isSupporter ?? false;
  const hasNoOrg = !userIsCso && !userIsSupporter;

  const orgContract =
    userOrgInfo &&
    userOrgInfo.contract &&
    userOrgInfo.contract.plan &&
    userOrgInfo.contract.plan.name;

  const pageUrl = window.location.href;
  const supporterId =
    supporterData?.mySupporterInfo?.edges[0]?.node?.id ?? null;

  const handleDownloadUsingOrgTicket = () => {
    if (userIsCso) {
      if (cso.totalTicket <= 0) {
        alert(
          "組織情報PDFをダウンロードするには、チケットが必要です。チケットは、「マイページ」または「オーガニゼーション_契約プランとメンバー」で購入ができます。"
        );
        return;
      }
    }
    if (userIsSupporter) {
      if (supporterTicket <= 0) {
        alert(
          "組織情報PDFをダウンロードするには、チケットが必要です。チケットは、「マイページ」または「オーガニゼーション_契約プランとメンバー」で購入ができます。"
        );
        return;
      }
    }
    setTimeout(() => {
      if (userIsSupporter) {
        refetchSupporterTicket();
      } else {
        refetchCSOTicket();
      }
    }, 5000);
    const baseUrl =
      process.env.REACT_APP_ENV === "production"
        ? "https://datestore.socialmap.jp"
        : "https://staging220923.socialmap.jp";
    const bucketUrl = `${baseUrl}/orgapi/createPDF?id=`;
    const ticketType = userIsCso ? "cso" : "supporter";
    const orgId = userIsCso ? userOrgInfo.id : supporterId;
    const token = localStorage.getItem("token");

    const url = `${bucketUrl}${selectedId}&ticket_type=${ticketType}&org_id=${orgId}&token=${token}`;
    window.open(url, "_blank");
  };

  const handleDownloadUsingPersonalTicket = (pdfId) => {
    if (userTicket <= 0) {
      alert(
        "組織情報PDFをダウンロードするには、チケットが必要です。チケットは、「マイページ」または「オーガニゼーション_契約プランとメンバー」で購入ができます。"
      );
      return;
    }
    setTimeout(() => {
      refetchUserTicket();
    }, 5000);
    const baseUrl =
      process.env.REACT_APP_ENV === "production"
        ? "https://datestore.socialmap.jp"
        : "https://staging220923.socialmap.jp";
    const bucketUrl = `${baseUrl}/orgapi/createPDF?id=`;
    const url = `${bucketUrl}${selectedId}&ticket_type=user&token=${localStorage.getItem(
      "token"
    )}`;

    window.open(url, "_blank");
  };

  //pdfダウンロードボタン押下
  const pdfDownloadHandle = (row) => {
    setSelectedId(row._original.id);
    setPricingModalOpen(true);
    return;
  };

  return (
    <>
      <Fragment>
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardHeader
                    className="org_title mb-2"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h4
                      style={{
                        marginLeft: 0,
                        fontWeight: 600,
                        marginBottom: 0,
                      }}
                    >
                      {title}
                    </h4>
                  </CardHeader>

                  <ReactTable
                    getTdProps={(state, rowInfo, column, instance) => {
                      return {
                        onClick: (e) => {
                          //if(column.id !== 'col-check'){
                          // 基本的な処理
                          //  return
                          //}
                        },
                      };
                    }}
                    data={orgListData}
                    showPagination={paginationComponent ? false : true}
                    columns={[
                      {
                        Header: "選択",
                        accessor: "checkbox",
                        width: 70,
                        Cell: ({ row }) => {
                          return (
                            <div style={{ textAlign: "center", width: "70px" }}>
                              <Input
                                value={row._original.id}
                                onChange={() => {
                                  handleCheckBox(row._original.id);
                                }}
                                checked={
                                  csvLists.includes(row._original.id)
                                    ? true
                                    : false
                                }
                                style={{ position: "relative", left: 10 }}
                                type="checkbox"
                              />
                            </div>
                          );
                        },
                      },
                      {
                        Header: "ロゴ",
                        accessor: "logoUrl",
                        width: 70,
                        sortMethod: (rowA, rowB) => {
                          if (rowA && rowB) {
                            return String(rowA)?.localeCompare(String(rowB));
                          }
                          if (rowA && !rowB) return -1;
                          if (!rowA && rowB) return 1;
                          return 0;
                        },
                        Cell: ({ row }) => {
                          return (
                            <div style={{ textAlign: "center", width: "100%" }}>
                              <img
                                src={row._original.logoUrl}
                                style={{
                                  width: "auto",
                                  height: "auto",
                                  maxHeight: "30px",
                                  maxWidth: "40px",
                                }}
                                onerror="this.onerror=null;this.src='http://example.com/existent-image.jpg';"
                                alt=""
                              />
                            </div>
                          );
                        },
                      },
                      {
                        Header: "組織名",
                        accessor: "name",
                        Cell: ({ row }) => {
                          return (
                            <Link
                              to={{
                                pathname: `/dashboards/plofile-organization/${row._original.pk}`,
                                // hash: `${row.name}`,
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              {row.name}
                              {row._original.isDissolve && <DissolveBadge />}
                            </Link>
                          );
                        },
                      },
                      {
                        Header: "国内所在地",
                        accessor: "prefecture",
                        Cell: ({ row }) => {
                          return (
                            <div style={{ textAlign: "center", width: "100%" }}>
                              {row._original.prefecture}
                            </div>
                          );
                        },
                      },
                      {
                        Header: "組織規模",
                        accessor: "revenueCategory.scale",
                        Cell: ({ row }) => {
                          return (
                            <div style={{ textAlign: "center", width: "100%" }}>
                              {row._original.revenueCategory.scale}
                            </div>
                          );
                        },
                      },
                      {
                        Header: "ダウンロード",
                        accessor: "revenueCategory.scale",
                        Cell: ({ row }) => {
                          return (
                            <a
                              id={row._index}
                              onClick={() => {
                                setSelectedOrg(row._original.name);
                                if (!isUnauthenticated) {
                                  pdfDownloadHandle(row);
                                } else {
                                  alert(
                                    "組織情報のダウンロードにはログインが必要です。"
                                  );
                                }
                              }}
                              href={pageUrl}
                              style={{ textAlign: "center", width: "100%" }}
                            >
                              PDF
                            </a>
                          );
                        },
                      },
                      {
                        Header: () => {
                          return (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                justifyContent: "center",
                              }}
                              className="hatena_box"
                            >
                              <span>情報度</span>
                              <span
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  fontSize: "13px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: "50%",
                                  border: "1px solid #adaeaf",
                                  color: "#adaeaf",
                                }}
                                id="quality"
                              >
                                ?
                              </span>
                              <UncontrolledTooltip
                                target="quality"
                                placement="top"
                              >
                                <div
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <p>
                                    星の数はSocial
                                    map上に掲載されている組織情報の充実度によって自動で変わります。
                                  </p>
                                  <p>星1：「組織概要」の記載</p>
                                  <p>星2：「活動国」「財務データ」の記載</p>
                                  <p>星3：「ミッションと連携方針」の記載</p>
                                </div>
                              </UncontrolledTooltip>
                            </div>
                          );
                        },
                        accessor: "publicInformationScore",
                        sortMethod: (rowA, rowB) => {
                          if (rowA > rowB) return 1;
                          if (rowB > rowA) return -1;
                          return 0;
                        },
                        minWidth: 70,
                        Cell: ({ row }) => {
                          const quality_score =
                            row?._original?.publicInformationScore ?? 0;
                          const max_quality = 3;

                          return (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "2px",
                                width: "100%",
                              }}
                            >
                              {new Array(quality_score)
                                .fill(0)
                                .map((item, idx) => {
                                  return (
                                    <div key={idx}>
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M9.04893 3.92731C9.34828 3.006 10.6517 3.006 10.951 3.92731L12.0206 7.21911C12.1545 7.63113 12.5384 7.91009 12.9717 7.91009H16.4329C17.4016 7.91009 17.8044 9.14971 17.0207 9.71911L14.2205 11.7536C13.87 12.0082 13.7233 12.4596 13.8572 12.8716L14.9268 16.1634C15.2261 17.0847 14.1717 17.8508 13.3879 17.2814L10.5878 15.247C10.2373 14.9923 9.76269 14.9923 9.4122 15.247L6.61203 17.2814C5.82832 17.8508 4.77384 17.0847 5.07319 16.1634L6.14276 12.8716C6.27663 12.4596 6.12997 12.0082 5.77949 11.7536L2.97932 9.71911C2.1956 9.14971 2.59838 7.91009 3.5671 7.91009H7.0283C7.46153 7.91009 7.84548 7.63113 7.97936 7.21911L9.04893 3.92731Z"
                                          fill="#646262"
                                        />
                                      </svg>
                                    </div>
                                  );
                                })}
                              {new Array(max_quality - quality_score)
                                .fill(0)
                                .map((item, idx) => {
                                  return (
                                    <div key={idx}>
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clip-path="url(#clip0_270_3987)">
                                          <path
                                            d="M9.04896 2.92664C9.34833 2.00537 10.6517 2.00538 10.951 2.92664L12.0208 6.21864C12.1547 6.63063 12.5386 6.90957 12.9718 6.90958L16.4333 6.90971C17.402 6.90975 17.8047 8.1493 17.0211 8.71871L14.2208 10.7534C13.8703 11.008 13.7237 11.4594 13.8575 11.8714L14.927 15.1635C15.2263 16.0847 14.1719 16.8508 13.3882 16.2815L10.5878 14.247C10.2373 13.9924 9.76272 13.9924 9.41225 14.247L6.61179 16.2815C5.82809 16.8508 4.77367 16.0847 5.07297 15.1635L6.14249 11.8714C6.27634 11.4594 6.1297 11.008 5.77924 10.7534L2.97894 8.71871C2.19528 8.1493 2.59804 6.90975 3.56672 6.90971L7.02818 6.90958C7.46137 6.90957 7.8453 6.63063 7.97918 6.21864L9.04896 2.92664Z"
                                            stroke="#646262"
                                            stroke-width="2"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_270_3987">
                                            <rect
                                              width="20"
                                              height="20"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                  );
                                })}
                            </div>
                          );
                        },
                      },
                      // {
                      //   Header: () => {
                      //     return (
                      //       <div
                      //         style={{
                      //           display: "flex",
                      //           alignItems: "center",
                      //           gap: "8px",
                      //           justifyContent: "center",
                      //         }}
                      //         className="hatena_box"
                      //       >
                      //         <span>信頼度</span>
                      //         <span
                      //           style={{
                      //             width: "20px",
                      //             height: "20px",
                      //             fontSize: "13px",
                      //             display: "flex",
                      //             alignItems: "center",
                      //             justifyContent: "center",
                      //             borderRadius: "50%",
                      //             border: "1px solid #adaeaf",
                      //             color: "#adaeaf",
                      //           }}
                      //           id="reliability"
                      //         >
                      //           ?
                      //         </span>
                      //         <UncontrolledTooltip
                      //           target="reliability"
                      //           placement="top"
                      //         >
                      //           <div
                      //             style={{
                      //               textAlign: "left",
                      //               whitespace: "no-wrap",
                      //             }}
                      //           >
                      //             <p>
                      //               月の数はSocial
                      //               map上に掲載されている組織情報の充実度によって自動で変わります。
                      //             </p>
                      //             <p>月1：「ネットワーク組織」の加盟</p>
                      //             <p>月2：「第三者認証」の実施</p>
                      //             <p>月3： 現在基準設定中</p>
                      //           </div>
                      //         </UncontrolledTooltip>
                      //       </div>
                      //     );
                      //   },
                      //   minWidth: 70,
                      //   accessor: "reliabilityScore",
                      //   sortMethod: (rowA, rowB) => {
                      //     if (rowA > rowB) return 1;
                      //     if (rowB > rowA) return -1;
                      //     return 0;
                      //   },
                      //   Cell: ({ row }) => {
                      //     // RELIABILITY COLUMN
                      //     const reliability_score =
                      //       row?._original?.reliabilityScore ?? 0;
                      //     const max_reliability = 3;
                      //     return (
                      //       <div
                      //         style={{
                      //           display: "flex",
                      //           alignItems: "center",
                      //           justifyContent: "center",
                      //           gap: "2px",
                      //           width: "100%",
                      //         }}
                      //       >
                      //         {new Array(reliability_score)
                      //           .fill(0)
                      //           .map((item, idx) => {
                      //             return (
                      //               <div key={idx}>
                      //                 <svg
                      //                   width="20"
                      //                   height="20"
                      //                   viewBox="0 0 20 20"
                      //                   fill="none"
                      //                   xmlns="http://www.w3.org/2000/svg"
                      //                 >
                      //                   <path
                      //                     d="M17.2929 13.2933C16.2886 13.7474 15.1738 14.0003 14 14.0003C9.58172 14.0003 6 10.4185 6 6.00026C6 4.82629 6.25287 3.71138 6.70712 2.70703C3.93137 3.96228 2 6.75563 2 10.0001C2 14.4183 5.58172 18.0001 10 18.0001C13.2443 18.0001 16.0376 16.0689 17.2929 13.2933Z"
                      //                     fill="#646262"
                      //                   />
                      //                 </svg>
                      //               </div>
                      //             );
                      //           })}
                      //         {new Array(max_reliability - reliability_score)
                      //           .fill(0)
                      //           .map((item, idx) => {
                      //             return (
                      //               <div key={idx}>
                      //                 <svg
                      //                   width="20"
                      //                   height="20"
                      //                   viewBox="0 0 20 20"
                      //                   fill="none"
                      //                   xmlns="http://www.w3.org/2000/svg"
                      //                 >
                      //                   <path
                      //                     d="M16.9618 12.796C16.098 13.1432 15.1546 13.3342 14.1667 13.3342C10.0245 13.3342 6.66667 9.97636 6.66667 5.83422C6.66667 4.84624 6.8577 3.90288 7.20484 3.03906C4.44707 4.14733 2.5 6.84673 2.5 10.0009C2.5 14.143 5.85786 17.5009 10 17.5009C13.1542 17.5009 15.8536 15.5538 16.9618 12.796Z"
                      //                     stroke="#646262"
                      //                     stroke-width="2"
                      //                     stroke-linecap="round"
                      //                     stroke-linejoin="round"
                      //                   />
                      //                 </svg>
                      //               </div>
                      //             );
                      //           })}
                      //       </div>
                      //     );
                      //   },
                      // },

                      // {
                      //   Header: "信頼度",
                      //   accessor: "status",
                      // },
                      // {
                      //   Header: "情報公開度",
                      //   accessor: "status",
                      // },
                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                    previousText="前へ"
                    nextText="次へ"
                    pageText=""
                    ofText="of"
                    rowsText=""
                    style={{ cursor: "pointer" }}
                  />

                  {/* Custom Pagination Button */}
                  {paginationComponent}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CSSTransitionGroup>
      </Fragment>
      <Modal
        isOpen={pricingModalOpen}
        toggle={() => setPricingModalOpen(!pricingModalOpen)}
        backdropClassName="reverted-backdrop"
        size="sm"
        contentClassName={styles["pricing-modal-content"]}
        className={styles["pricing-modal-dialog"]}
      >
        <ModalBody>
          <div
            style={{
              marginTop: "70px",
              textAlign: "center",
              fontSize: "20px",
            }}
          >
            組織情報ダウンロード
          </div>
          <div
            style={{
              margin: "24px 0",
              textAlign: "center",
            }}
          >
            組織名: {selectedOrg}
          </div>
          <div
            style={{
              textAlign: "center",
            }}
          >
            <p>
              1組織情報PDFをダウンロードで、チケットが1枚消費されます。
              <br />
              組織チケットと個人チケットについてやや購入方法は、FAQをご確認ください。
            </p>
          </div>
          <div
            style={{
              paddingLeft: "16px",
              paddingRight: "16px",
            }}
          >
            {/* Download Using Org Ticket */}
            {!hasNoOrg && (
              <button
                onClick={handleDownloadUsingOrgTicket}
                style={{
                  backgroundColor: "#44CAE1",
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  padding: "12px 24px",
                  width: "100%",
                  textAlign: "center",
                  marginBottom: "8px",
                }}
              >
                組織チケットでダウンロードする
              </button>
            )}
            {/* Download Using Personal Ticket */}
            <button
              onClick={handleDownloadUsingPersonalTicket}
              style={{
                backgroundColor: "#44CAE1",
                color: "white",
                borderRadius: "4px",
                border: "none",
                width: "100%",
                textAlign: "center",
                padding: "12px 24px",
                marginBottom: "70px",
              }}
            >
              個人チケットでダウンロードする
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default InfoTable;
